import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/i18n"; // side-effect: bootstrap i18next before App mounts
import { App } from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
